import { render, staticRenderFns } from "./Detailspage.vue?vue&type=template&id=25b6f609&scoped=true&"
import script from "./Detailspage.vue?vue&type=script&lang=js&"
export * from "./Detailspage.vue?vue&type=script&lang=js&"
import style0 from "./Detailspage.vue?vue&type=style&index=0&id=25b6f609&scoped=true&lang=css&"
import style1 from "./Detailspage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b6f609",
  null
  
)

export default component.exports